import { DateRange } from "react-day-picker";
import { DashboardFilters } from "./dashboard.type";

export enum DashboardComponentKind {
  BarChart = 'bar_chart',
  PieChart = 'pie_chart',
  AreaChart = 'area_chart',
  LineChart = 'line_chart',
  Value = 'value',
  Table = 'table',
}

export enum DashboardComponentDateFilters {
  StartDate = 'start_date_gteq',
  EndDate = 'end_date_lteq',
}

export enum DashboardComponentGeneratorPropertiesFilterMode {
  Default = 'default',
  Hidden = 'hidden',
}

export type DashboardComponentFilters = DashboardComponentDateFilters | DashboardFilters;

export type DashboardComponentFiltersParams = Partial<Record<DashboardComponentFilters, any>>;

export type DashboardComponentFiltersProp = DashboardComponentFiltersParams & { date: DateRange | undefined }

export type DashboardComponentFiltersParamsParsed = Partial<Record<DashboardComponentFilters, string | number | boolean | null | undefined>>;

export type DashboardComponentFilterDefinition = {
  type: string;
};

export type DashboardComponentFilterDefinitions = Partial<
  Record<DashboardComponentFilters, DashboardComponentFilterDefinition>
>;

export type DashboardComponentGeneratorData = {
  available_kinds: DashboardComponentKind[];
  filters: DashboardComponentFilterDefinitions;
  klass: string;
  subtitle: string;
  title: string;
}

export type DashboardComponentChartData = Record<string, any>;

export type DashboardComponentGeneratorPropertiesFilter = {
  key: DashboardComponentFilters;
  value: string | number | boolean | null | undefined;
  mode: DashboardComponentGeneratorPropertiesFilterMode;
}

export type DashboardComponentData = {
  dashboard_id: string;
  data: {
    data: DashboardComponentChartData[];
    kind: DashboardComponentKind;
    primary_settings: {
      format_parser: string;
      query_identifier: keyof DashboardComponentChartData;
    };
    layout: 'vertical' | 'horizontal',
    series_settings: {
      [key: string]: {
        color: string;
        format_parser: string;
        label: string | null;
        stack_id: string;
      };
    };
    subtitle: string;
    title: string;
  };
  definition: DashboardComponentGeneratorData;
  generator_klass: string;
  generator_properties: {
    kind: DashboardComponentKind;
    filters: DashboardComponentGeneratorPropertiesFilter[]
  };
  height: number;
  id: string;
  start_x: number;
  start_y: number;
  width: number;
}

export type DashboardComponentResponse = {
  data: {
    data: DashboardComponentData
  };
};

export type DashboardComponentChartProps = {
  chartData: DashboardComponentData['data'];
  dashboardComponentUpdatedAt: number;
}
